export default __webpack_public_path__ + "static/edit_collection-8fe09a1ad49c32e192e37daddedc101f.webp";